import React from "react";

function ProductA() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Product A</h1>
      <p style={{ color: "gray" }}>Coming soon.</p>
    </div>
  );
}

export default ProductA;
